import { render, staticRenderFns } from "./ModalHistoricoMicroArea.vue?vue&type=template&id=d9d73ba0"
import script from "./ModalHistoricoMicroArea.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoMicroArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports